module.exports = __webpack_public_path__ + "static/media/linkedin.4f2bc978.svg";